import { XAxisPlotLinesOptions } from 'highcharts';

export const ticksToTickInterval = (
  ticks: Date[],
  defaultTickInterval: number
): number => {
  const ticksToTickInterval_ = (
    firstTicks: Date,
    secondTicks: Date
  ): number => {
    return Math.round(
      (secondTicks.getTime() - firstTicks.getTime()) / 1000 / 60 / 60 / 24
    );
  };
  if (ticks[0] !== undefined && ticks[1] !== undefined)
    return ticksToTickInterval_(ticks[0], ticks[1]);
  return defaultTickInterval;
};

export const ticksToPlotLines = (
  ticks: Date[],
  options?: Omit<XAxisPlotLinesOptions, 'value'>
): XAxisPlotLinesOptions[] => {
  const ticksToPlotLines_ = (
    firstTick: Date,
    remainTicks: Date[]
  ): XAxisPlotLinesOptions[] => {
    const ts = [firstTick, ...remainTicks];
    return ts.map(t => {
      return {
        ...options,
        color: '#dddddd',
        value: Math.round(
          (t.getTime() - firstTick.getTime()) / 24 / 60 / 60 / 1000
        ),
        width: 1,
      };
    });
  };
  const [fst, ...remain] = ticks;
  return ticksToPlotLines_(fst, remain);
};
